import EventBase from './EventBase'
import EventID from './EventID'

/**
 *  104	快进剧情
 */

export default class EventQuickPlay extends EventBase {
  /**
   * 快进剧情构造函数
   */
  constructor() {
    super()
    this.Parameter = ['0', '']
  }
  /**
   * 事件ID
   */
  Code = EventID.QuickPlay
  // #region 类的相关绑定参数都在这里
  /**
   * 是否快进
   */
  get QuickPlay() {
    return parseInt(this.Parameter?.[0] || '')
  }
  set QuickPlay(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

  /**
   * 显示信息
   */
  get Description() {
    return this.Parameter?.[1] || ''
  }
  set Description(value) {
    this.Parameter && (this.Parameter[1] = value.toString())
  }

  //   // #endregion
}
